import { SCORE_DETAILS } from "@/pages/hippo/constants";

export function ScoreDetailModal({ isOpen, onClose, scoreType, value }) {
  if (!isOpen || !scoreType) return null;
  
  const details = SCORE_DETAILS[scoreType];
  if (!details) return null;
  
  const getColor = () => {
    if (value >= 70) return { text: "text-cipher-green", bg: "bg-cipher-green/20", ring: "#006A4D" };
    if (value >= 50) return { text: "text-cipher-gold", bg: "bg-cipher-gold/20", ring: "#C5A059" };
    return { text: "text-gray-400", bg: "bg-gray-500/20", ring: "#9CA3AF" };
  };
  
  const colors = getColor();
  const radius = 35;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (value / 100) * circumference;
  
  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div 
        className="w-full max-w-sm bg-[#1a1a1a] border border-white/20 rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`p-6 ${colors.bg} border-b border-white/10`}>
          <div className="flex items-center gap-4">
            <div className="relative w-20 h-20">
              <svg viewBox="0 0 80 80" className="transform -rotate-90">
                <circle cx="40" cy="40" r={radius} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="6" />
                <circle
                  cx="40" cy="40" r={radius}
                  fill="none" stroke={colors.ring} strokeWidth="6" strokeLinecap="round"
                  strokeDasharray={circumference} strokeDashoffset={strokeDashoffset}
                />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-xl font-bold text-white">{value}</span>
                <span className="text-[10px] text-white/50">/100</span>
              </div>
            </div>
            <div className="flex-1">
              <h3 className={`text-lg font-bold ${colors.text}`}>{details.name}</h3>
              <p className="text-sm text-white/70 mt-1 leading-snug">{details.description}</p>
            </div>
          </div>
        </div>
        <div className="p-5">
          <p className="text-xs text-white/50 uppercase tracking-wider mb-2">What this means for your property</p>
          <p className="text-sm text-white/80 leading-relaxed">{details.explanation}</p>
        </div>
        <div className="px-5 pb-5">
          <button
            onClick={onClose}
            className="w-full py-3 rounded-xl bg-white/10 hover:bg-white/15 border border-white/10 text-white text-sm font-medium transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
